<template>
  <div class="Index">
    <closeZone></closeZone>
     <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">购物消费</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goDish">
        <div class="module_left">手机买菜</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Dish1">
          <div class="module_right_icon2 Dish2">
            <div class="module_right_icon3 Dish3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goEat">
        <div class="module_left">手机点餐</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Eat1">
          <div class="module_right_icon2 Eat2">
            <div class="module_right_icon3 Eat3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goRefund">
        <div class="module_left">网购退货</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Refund1">
          <div class="module_right_icon2 Refund2">
            <div class="module_right_icon3 Refund3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goChange">
        <div class="module_left">网购换货</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Change1">
          <div class="module_right_icon2 Change2">
            <div class="module_right_icon3 Change3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goPower">
        <div class="module_left">网购维权</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Power1">
          <div class="module_right_icon2 Power2">
            <div class="module_right_icon3 Power3"></div>
          </div>
        </div>
      </div>
    </div>
    <!--解锁畅享权益-->
    <van-popup v-model="showPopup" position="bottom" :overlay="true">
      <div class="popup-info">
        <div class="popup-info-bk">
          <div class="popup-info-close" @click="handleCloseVip"></div>
          <div class="popup-info-quanyi"></div>
          <div class="popup-info-vip"  @click="handleToggleVip"></div>
        </div>
      </div>
    </van-popup>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import VanPopup from "vant/lib/popup";
import 'vant/lib/popup/style'
export default {
  name: "index",
  components: {
    VanPopup,
  },
  data() {
    return {
      isVip: false,
      //畅享权益
      direction: 'btt',
      drawer: false,
      showPopup:false,
    };
  },
  created() {},
  mounted() {
    this.isVip = this.$store.getters.isVip
    // const urlParams = new URLSearchParams(window.location.search)
    // this.isVip = urlParams.get('isVip') === '1'
    // console.log(this.isVip)
  },

  computed:{
    isVipUser() {
      return this.isVip
    }
  },

  beforeDestroy() {},

  methods: {
    //关闭畅享权益
    handleCloseVip() {
      this.showPopup = false
    },

    handleToggleVip(){
      wx.miniProgram.redirectTo({
        url: `/pagesPay/pay/index?orderType=vip`
      })
    },

    checkVip () {
      if (!this.isVip) {
        this.showPopup = true
        return false
      }
      return true
    },

    async goDish() {
      if (!this.checkVip()) return
      this.$router.push({
        path: "/shopping/dish/index",
      });
    },
    async goEat() {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: "/shopping/eat/index",
      });
    },
    async goRefund() {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: "/shopping/refund/index",
      });
    },
    async goChange() {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: "/shopping/change/index",
      });
    },
    async goPower() {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: "/shopping/power/index",
      });
    },
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
  },
};
</script>
<style>
.popup-info{
  width: 100%;
  height: 85vh;
  position: relative;
}
.popup-info-close{
  position: absolute;
  top: 11%;
  right: 1.5%;
  width: 15%;
  height: 9%;
  background: url(@/assets/zone/closeQuanyi.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-bk{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(@/assets/zone/order.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-quanyi{
  position: absolute;
  top: 30%;
  left: 13%;
  width: 75%;
  height: 45%;
  background: url(@/assets/zone/quanyi.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-vip{
  position: absolute;
  top: 80%;
  left: 20%;
  width: 70%;
  height:19%;
  background: url(@/assets/zone/vip.png) no-repeat center;
  background-size: 100% 100%;
}

.van-popup {
  border-radius: 20px 20px 0 0;
  background: none !important;
}
</style>
<style scoped lang="less">
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
/* 玫红 */
background: linear-gradient(180.00deg, rgb(249, 92, 159) 6.107%,rgb(255, 131, 184) 20.611%,rgb(255, 235, 228) 99.237%);
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 50px;
    top: 40px;
    z-index: 0;
    width: 374px;
    height: 250px;
    background: url(@/assets/shopping/shoppingIndex/shoppingIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
  }
}

.module_box {
  width: 100%;
  //margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  //padding-right: 10px;
  //display: flex;
  //flex-wrap: wrap;
  //gap: 18px;
  //margin: 0 30px;
  //width: 90%;
  //margin: 0 auto;
  padding:0 5%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: space-between;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 48%;
    padding: 27px 0;
    height: 95px;
    background: #ffffff;
    border-radius: 15px;
    //margin-bottom: 30px;
    //margin-right: 30px;
    .left_lock{
      position: absolute;
      top: 0;
      left: 0;
      width: 26%;
      height: 30%;
      background: url("@/assets/zone/lock.png") no-repeat;
      background-size: 100% 100%;
    }
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }
  }
  .Dish1 {
    background: url("@/assets/colorBg/green1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Dish2 {
    background: url("@/assets/colorBg/green2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Dish3 {
    background: url("@/assets/shopping/shoppingIndex/dish.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Eat1 {
    background: url("@/assets/colorBg/blue1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Eat2 {
    background: url("@/assets/colorBg/blue2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Eat3 {
    background: url("@/assets/shopping/shoppingIndex/eat.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Refund1 {
    background: url("@/assets/colorBg/pink1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Refund2 {
    background: url("@/assets/colorBg/pink2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Refund3 {
    background: url("@/assets/shopping/shoppingIndex/refund.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Change1 {
    background: url("@/assets/colorBg/orange1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Change2 {
    background: url("@/assets/colorBg/orange2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Change3 {
    background: url("@/assets/shopping/shoppingIndex/change.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Power1 {
    background: url("@/assets/colorBg/purple1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Power2 {
    background: url("@/assets/colorBg/purple2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Power3 {
    background: url("@/assets/shopping/shoppingIndex/power.png") no-repeat center;
    background-size: 100% 100%;
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
</style>
